<template>
    <div class="-section-colTerminal col-xs-8 col-padding">
        <div id="terminal" class="terminal-block">
            <div class="block-panel">
                <span class="block-panel-btn"></span>
                <span class="block-panel-btn"></span>
                <span class="block-panel-btn"></span>
            </div>
            <div class="block-content">
                <div class="block-content-welcome">
                     {{  new Date() | moment('MMMM Do YYYY, kk:mm') }} $ <span class="write-to-us">./NapiszDoNas</span>
                </div>
                <table>

                    <tr v-bind:class="{ blink_me: !phone, active: phone }">
                        <td class='user-prompt'><span>>>></span></td>
                        <td class='input-field'>telefon:</td>
                        <td>
                            <input class='input-field' v-model="phone">
                        </td>
                    </tr>

                    <tr v-bind:class="{ blink_me: !email, active: email }">
                        <td class='user-prompt'><span>>>></span></td>
                        <td class='input-field'>e-mail:</td>
                        <td><input class='input-field' v-model="email"></td>
                    </tr>

                    <tr v-bind:class="{ blink_me: !text, active: text }">
                        <td class='user-prompt'><span>>>></span></td>
                        <td class='input-field'>text:</td>
                        <td><textarea class="input-field" rows="4" cols="50" maxlength="200"
                                      v-model="text"></textarea></td>
                    </tr>

                </table>

                <transition name="fade">
                    <div class="send-btn">
                        <button v-if="canBeSend()" v-on:click="sendMessage">wyślij</button>
                    </div>
                </transition>

                <transition name="fade">
                    <div class="err-status-bar" v-if="errorResultMsg">
                        <span class="user-prompt">>>></span>
                        <div class="input-field">{{ errorResultMsg }}</div>
                    </div>
                </transition>
                <transition name="fade">
                    <div class="succ-status-bar" v-if="successResultMsg">
                        <span class="user-prompt">>>></span>
                        <div class="input-field">{{ successResultMsg }}</div>
                    </div>
                </transition>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                phone: '',
                email: '',
                text: '',
                errorResultMsg: '',
                successResultMsg: ''
            }
        },
        methods: {
            canBeSend : function () {
                return this.phone !== '' && this.email !== '' && this.text !== ''
            },
            sendMessage: function () {
                this.$http.post('/send', {
                phone: this.phone,
                email: this.email,
                text: this.text
                }).then(response => {
                    if (response.body.result == 'OK') {
                        this.successSend();
                        var self = this;
                        setTimeout(
                            function() {
                                self.phone = '';
                                self.email = '';
                                self.text = '';
                                self.successResultMsg = '';
                                self.errorResultMsg = '';
                            }, 5000);

                    }
                    else
                        this.failToSend();
                }, response => {
                    this.failToSend();
                });
            },
            failToSend: function () {
                this.errorResultMsg = 'Nie udało się wysłać wiadomości :(';
                var self = this;
                setTimeout(
                    function() {
                    self.errorResultMsg = '';
                    }, 2000);
            },
            successSend: function () {
                this.successResultMsg = 'Wiadomość została wysłana !';
            }
        }
    }
</script>

<style scoped>
    .write-to-us {
        color: white;
    }

    table {
        color: white;
    }

    table td {
        padding: 4px;
        vertical-align: top;
    }

    input, textarea {
        background-color: black;
        border: 0px solid;
        resize: none;
        width: 80%;
    }

    textarea:focus, input:focus {
        outline: none;
    }

    .user-prompt {
        font-size: 16px;
        color: white;
        letter-spacing: -2px;
        padding-top: 6px;
    }

    .input-field {
        font-size: 20px;
    }

    .send-btn {
        text-align:center;
    }

    .send-btn button {
        background-color: black;
        border: 1px solid white;
        color: white;
        font-weight: bold;
        margin: 0 auto;
    }

    .send-btn button:hover {
        color: #048c4c;
    }

    .send-btn button:focus {
        outline: 0;
    }

    .err-status-bar span,
    .succ-status-bar span {
        float: left;
    }

    .err-status-bar div {
        color: #e20d07;
        letter-spacing: 0px;
        float: left;
        margin-left: 5px;
    }

    .succ-status-bar div {
        color: #048c4c;
        letter-spacing: 0px;
        float: left;
        margin-left: 5px;
    }

    .err-status-bar,
    .succ-status-bar {
        margin-top: 10px;
    }

    .active {
        color: #048c4c;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// Terminal.vue?40c9a3f4